import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getECGLayout(_traceECG, frequency) {
  const traceECG = orderByDate(_traceECG);
  const color = "#F99";
  const totale_punti_riga = 8 * frequency;
  const scaleFactorX = 200 / totale_punti_riga;
  const scaleFactorY = 20;
  const offsetY = 0.5;
  const thickGrid = 2,
    normalGrid = 1.5,
    thinGrid = 0.6;

  let layout = {
    interactivityEnabled: false,
    theme: "light2",
    zoomEnabled: false,
    height: 250,
    // title: {
    //   text: "Grafico ECG",
    //   horizontalAlign: "left",
    //   fontColor: "black",
    // },
    axisY: {
      stripLines: [],
      gridColor: color,
      lineColor: color,
      gridThickness: thickGrid,
      tickThickness: 0,
      minimum: -20,
      maximum: 20,
      interval: 20,
      labelFormatter: function (e) {
        return "";
      },
    },
    axisX: {
      stripLines: [],
      gridColor: color,
      lineColor: color,
      // tickThickness: 0,
      gridThickness: thickGrid,
      tickLength: 5,
      maximum: 200,
      minimum: 0,
      interval: 25,
      labelFormatter: function (e) {
        const tick = e.chart.options.ecg_index * 8 + e.value / 25;
        return e.value === 0 ? "" : `${tick}s`;
      },
    },
    data: [
      {
        type: "line",
        color: "black",
        dataPoints: traceECG.map((el) => ({
          x: el.x * scaleFactorX,
          y: (el.y - offsetY) * scaleFactorY,
        })),
      },
    ],
  };

  // draw strip lines
  for (let i = layout.axisY.minimum; i < layout.axisY.maximum; i += 1) {
    layout.axisY.stripLines.push({
      value: i,
      thickness: Math.abs(i) % 5 != 0 ? thinGrid : normalGrid,
      color: color,
    });
  }

  for (let i = layout.axisX.minimum; i < layout.axisX.maximum; i += 1) {
    layout.axisX.stripLines.push({
      value: i,
      thickness: Math.abs(i) % 5 != 0 ? thinGrid : normalGrid,
      color: color,
    });
  }

  return layout;
}

export function normalizeAmplitude(traceECG) {
  const ecgSignal = traceECG.map((el) => el.y);
  const min = Math.min(...ecgSignal);
  const max = Math.max(...ecgSignal);
  const normalized = ecgSignal.map((sample) => (sample - min) / (max - min));
  traceECG.forEach((el, index) => (traceECG[index].y = normalized[index]));
  return traceECG;
}

function ecgRawToRecords(origin, ecgRaw) {
  if (Array.isArray(ecgRaw)) {
    return ecgRaw;
  }

  let stringa =
    typeof ecgRaw === "string" ? ecgRaw : JSON.stringify(ecgRaw ?? "");

  if (origin === "viatom_bp2") {
    stringa = stringa.replace("[", "").replace("]", "");
    return stringa.split(",").map((value) => parseFloat(value.trim()));
  }

  stringa = stringa.replace("b'", "").replace("'", "");
  stringa = stringa.replaceAll("\\\\n", "\n");
  return stringa.split("\n").filter(Boolean);
}

/** Costruisce i layout CanvasJS da ECGRaw (array inline o contenuto file legacy). */
export function buildECGLayoutsFromRaw(report, ecgRaw) {
  const origin = report?.origin;
  const records = ecgRawToRecords(origin, ecgRaw);

  if (!records.length) {
    throw new Error("Dati ECG vuoti");
  }

  const secondi_per_riga = 8;
  const freq_rilevazione = origin === "viatom_bp2" ? 125 : 200;
  const totale_punti_riga = secondi_per_riga * freq_rilevazione;

  const nrounds =
    origin === "viatom_bp2"
      ? Math.ceil(records.length / totale_punti_riga)
      : Math.floor(records.length / totale_punti_riga);

  const layouts = [];

  for (let round = 0; round < nrounds; round++) {
    const traceECG = [];

    for (let i = 0; i < totale_punti_riga; i++) {
      const index = i + round * totale_punti_riga;
      if (origin === "viatom_bp2" && records[index] === undefined) {
        break;
      }
      if (records[index] === undefined) {
        break;
      }

      const y =
        origin === "viatom_bp2"
          ? Math.round(Number(records[index]) * 100)
          : parseInt(String(records[index]).split(";")[2], 10);

      traceECG.push({ x: i, y });
    }

    if (traceECG.length === 0) {
      continue;
    }

    const normalized = normalizeAmplitude(traceECG);
    const layout = getECGLayout(normalized, freq_rilevazione);
    layout.ecg_index = round;
    layouts.push(layout);
  }

  if (layouts.length === 0) {
    throw new Error("Impossibile costruire il grafico ECG");
  }

  return layouts;
}
